module.exports = __webpack_public_path__ + "static/img/公众号.84e44f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/milan/公众号.png
// module id = kZ5b
// module chunks = 1